export default __webpack_public_path__ + "static/media/CAL64250.235b98fb.jpg";